export const THEME_DARK_MODE = 'dark';
export const THEME_LIGHT_MODE = 'light';

export const FALLBACK_THEME = {
  name: 'Evolve IP',
  light: {
    primary: '#F47920',
    secondary: '#444444',
    surface: '#F2F3F5',

    info: '#77A8DA',
    error: '#F44336',
    success: '#4EA96D',
    warning: '#FCCC4A',
    accent: '#607d8b'
  },
  dark: {
    primary: '#F47920',
    secondary: '#444444',
    surface: '#444444',

    info: '#77A8DA',
    error: '#F44336',
    success: '#4EA96D',
    warning: '#FCCC4A',
    accent: '#607d8b'
  }
};
